import { SUPPORTED_CURRENCY_GROUPS } from '@constants';

const currencySymbolFor = (currency?: string | null): string =>
  SUPPORTED_CURRENCY_GROUPS.flatMap((group) => group.currencies).find(
    (supportedCurrency) => supportedCurrency.code === currency
  )?.symbol ?? '£';

const amountWithTwoToFourDecimals = new Intl.NumberFormat('en-GB', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
  useGrouping: false,
});

export function formatPrice(
  price?: number | null,
  currency?: string | null,
  missingPriceText = 'TBC'
): string {
  if (price == null) return missingPriceText;
  return `${currencySymbolFor(currency)}${amountWithTwoToFourDecimals.format(
    price
  )}`;
}
